/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

/**
 * Default Application Version
 * 
 * This constant is used as a fallback version when the version cannot be
 * determined from package.json or environment variables.
 * 
 * This value is automatically updated by the release script:
 *   npx tsx product/scripts/release.ts <version>
 */
export const DEFAULT_VERSION = '0.10.3';

